// Date 2021-08-02 17:31:47

import sithMesRitaCamera from "@/store/sithMes/rita/SithMesRitaCameraStore.js";
import sithMesRitaTestTask from "@/store/sithMes/rita/SithMesRitaTestTaskStore.js";

const genericEntities = [
    'sithMesRitaCamera',
    'sithMesRitaTestTask'
]

const entities = {
    sithMesRitaCamera,
    sithMesRitaTestTask
}

export {genericEntities}

export default entities